import React from 'react';
import DrawerMenu from 'react-modern-drawer';
import CloseBtn from '../../../assets/images/close-drawer.svg';
import NEDetails from './NEDetails';

interface NEDrawerProps {
    open: boolean;
    onClose: () => void;
    ne: any;
  }

const NEDrawer: React.FC<NEDrawerProps> = ({
  open, onClose, ne,
}) => {
  return (
    <DrawerMenu
      enableOverlay
      className="my-network-node-drawer"
      open={open}
      onClose={onClose}
      duration={100}
      direction="right"
    >
      <div
        className="close-drawer-btn"
        onClick={onClose}
      >
        <img src={CloseBtn} alt="Close Drawer" />
      </div>
      <NEDetails ne={ne} />
    </DrawerMenu>
  );
};

export default NEDrawer;
